import './depositRenovatedItem.scss';
// vendors
import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
// helpers
import { getDateCamelCaseShortMonth } from 'utilities/dateHelper';

const DepositRenovatedItem = ({ dueDate, handleClick }) => {
    const { formatText } = i18n;
    const formattedDate = getDateCamelCaseShortMonth(dueDate);
    return (
        <div className="deposit-renovated-item">
            <span className="deposit-renovated-item__icon-success-green"></span>
            <div>
                <p className="deposit-renovated-item__text">
                    {formatText('deposits-deposits_renovatedDepositText', [formattedDate])}
                </p>
                <p className="deposit-renovated-item__link" onClick={handleClick}>
                    {formatText('deposits-deposits_renovatedDepositLink')}
                </p>
            </div>
        </div>
    );
}

PropTypes.DepositRenovatedItem = {
    dueDate: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
}

export default DepositRenovatedItem;